var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-sidebar',{attrs:{"type":"is-light","fullheight":_vm.fullheight,"fullwidth":_vm.fullwidth,"overlay":_vm.overlay,"right":_vm.right,"can-cancel":_vm.canCancel},on:{"close":_vm.sidebarClosed},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }